var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('edit-frame',{attrs:{"width":"100%","isEditing":_vm.editMode,"hideControls":true}},[_c('v-textarea',{attrs:{"rules":[
      _vm.$validation.vuetify.single({
        length: { minimum: 0, maximum: 120 },
        presence: true,
      }),
    ],"outlined":"","dense":"","label":"Beschreibung","height":"100px","disabled":!_vm.editMode},on:{"input":_vm.onInput},model:{value:(_vm.editedDescription),callback:function ($$v) {_vm.editedDescription=$$v},expression:"editedDescription"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }